import React, { useMemo } from 'react';
import { Card, CardGroup } from 'react-bootstrap';
import { getValorArrecadado } from '../emendaUtils';

const toNumber = (value) => {
  const number = Number(value);
  return Number.isNaN(number) ? 0 : number;
};

const formatMoney = (value) =>
  Number(value).toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

export default function Totalizadores({ emendas = [] }) {
  const totalizadores = useMemo(() => [
    {
      label: 'Receitas',
      value: emendas.reduce((total, emenda) => total + toNumber(getValorArrecadado(emenda)), 0),
    },
    {
      label: 'Empenhado (atualizado)',
      value: emendas.reduce((total, emenda) => total + toNumber(emenda.totalEmpenhado), 0),
    },
    {
      label: 'Liquidado',
      value: emendas.reduce((total, emenda) => total + toNumber(emenda.totalLiquidado), 0),
    },
    {
      label: 'Pago',
      value: emendas.reduce((total, emenda) => total + toNumber(emenda.totalPago), 0),
    },
  ], [emendas]);

  return (
    <CardGroup className='my-2 emenda-totalizadores'>
      {totalizadores.map((totalizador) => (
        <Card key={totalizador.label}>
          <Card.Body>
            <Card.Title>{totalizador.label}</Card.Title>
            <h3 className='mb-0 d-flex justify-content-between'>
              <span>R$</span>
              <span>{formatMoney(totalizador.value)}</span>
            </h3>
          </Card.Body>
        </Card>
      ))}
    </CardGroup>
  );
}
